import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `<app-index></app-index>`
})
export class AppComponent implements OnInit {
    constructor() { }
    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/app.component.ts